<script setup>
// import DatabaseTypeBioPanel from '@/views/apps/databaseType/view/DatabaseTypeBioPanel.vue'
// import DatabaseTypeTabDetails from '@/views/apps/databaseType/view/DatabaseTypeTabDetails.vue'
// import { useDatabaseTypeStatusStore } from '@/composables/useGlobalStore'

const route = useRoute('apps-databaseType-view-id')
const databaseTypeTab = ref(null)
const databaseTypeStatusStore = useDatabaseTypeStatusStore()
const { data: databaseTypeData } = await useApi(`/apps/databaseTypes/${route.params.id}`)
// const databaseType = computed(() => databaseTypeStatusStore.mapStatusToDatabaseType(databaseTypeData.value))

definePage({
  meta: {
    action: 'read',
    subject: 'databases',
  },
})
</script>

<template>
  <VRow v-if="databaseType">
    <VCol cols="12" md="5" lg="4">
      <!-- <DatabaseTypeBioPanel :database-type-data="databaseType" /> -->
    </VCol>

    <VCol cols="12" md="7" lg="8">
      <VTabs v-model="databaseTypeTab" class="v-tabs-pill">
        <VTab v-for="tab in [
          { title: 'Details', component: DatabaseTypeTabDetails },
        ]" :key="tab.title">
          {{ tab.title }}
        </VTab>
        <VTabItem v-for="tab in [
          { title: 'Details', component: DatabaseTypeTabDetails },
        ]" :key="tab.title">
          <component :is="tab.component" :database-type-data="databaseType" />
        </VTabItem>
      </VTabs>
    </VCol>
  </VRow>
</template>
